import React, { useEffect, useMemo } from "react";

import { useHistory, useParams } from 'react-router-dom';

import * as NavigationUtils from '../../utils/navigation';

import SignatureSuccess from "./SignatureSuccess";

import { useWindowDimensions } from "../../utils/windowDimensionSize";
import { usePatientFormContext } from "../../contexts/PatientForm";

function FormSignatureSucessContainer() {
	const history = useHistory();
	const { code } = useParams();
	const { form } = usePatientFormContext();

	useEffect(() => {
		if (!form) {
			return NavigationUtils.navigate(history, `/privacy-policy/${code}`);
		}
	}, [form, code, history]);

	const { width } = useWindowDimensions();

	const isDesktop = useMemo(() => width >= 600, [width]);

	return (
		<SignatureSuccess
			form={form}
			isDesktop={isDesktop}
		/>
	)
}

export default FormSignatureSucessContainer;
